import get from 'lodash/get';
import merge from 'lodash/merge';
import { ReactSelectStyleKeysEnum, defaultBaseSelectStyles } from './constants';

// NOTE: Customizing this 3rd party tool (react-select) requires specifying styles in a particular
//       format. For reference, please refer to their docs on
//       styling: https://react-select.com/styles . This may also be useful for further
//       customization: https://react-select.com/components
//
// styleObject = {
//    control -> item that opens dropdown menu
//    singleValue -> selected value inside of control
//    dropdownIndicator -> icon showed in dropdown bar
//    indicatorSeparator -> separator (vertical bar by default)
//    menu -> dropdown menu
//    option -> options/row-items inside of the dropdown menu
//    ... (and so on, please see documentation)

// customStyles -> object representing styles that can be overwritten on default components (such as
//    adding margin to the container)
// additionalAttributes -> object representing new attributes/styles specific to the type of
//    dropdown (i.e. adding multiValue styles or removing clearIndicator styles, which are
//    specific to multi-select dropdowns)
export const getCombinedStyles = (customStyles, additionalAttributes = {}) => {
  const baseStyles = {
    container: base => ({
      height: '32px',
      ...base,
      ...customStyles.container,
    }),
    control: base => ({
      ...base,
      ...customStyles.control,
      boxShadow: 'none',
    }),
    dropdownIndicator: base => ({
      ...base,
      ...customStyles.dropdownIndicator,
      color: '#715c8e',
      '&:hover': {
        color: '#715c8e',
      },
    }),
    indicatorSeparator: () => null,
    menu: base => ({
      ...base,
      ...customStyles.menu,
      marginTop: 0,
    }),
    menuList: base => ({
      ...base,
      ...customStyles.menuList,
    }),
    option: (base, { data, isFocused, isSelected }) => {
      let backgroundColor = null;
      if (isFocused || isSelected) {
        backgroundColor = '#f0f0f0';
      }
      return ({
        ...base,
        ...customStyles.option,
        backgroundColor,
        color: data.color || 'black',
      });
    },
  };
  return merge({}, baseStyles, additionalAttributes);
};


export const processCustomStyles = customStyles => {
  const styleKeys = Object.values(ReactSelectStyleKeysEnum);
  const finalStyles = {};
  styleKeys.forEach(styleKey => {
    finalStyles[styleKey] = {
      ...(get(defaultBaseSelectStyles, styleKey) ?? {}),
      ...(get(customStyles, styleKey) ?? {}),
    };
  });
  return finalStyles;
};

export const computeOptionData = (
  options,
  selectedOptions,
  isMulti = false,
  placeholder = null,
) => {
  const selectedOptionsArray = !Array.isArray(selectedOptions)
    ? [selectedOptions]
    : selectedOptions;
  let processedValues = [];
  let longestOptionLength = 0;

  options.forEach(option => {
    const { value, label } = option;
    if (selectedOptionsArray.includes(value)) {
      if (isMulti) {
        processedValues.push(option);
      } else {
        processedValues = [option];
      }
    }
    if (label.length > longestOptionLength) {
      longestOptionLength = label.length;
    }
    if (placeholder && placeholder.length > longestOptionLength) {
      longestOptionLength = placeholder.length;
    }
  });

  processedValues = processedValues.filter(
    option => option.isFixed,
  ).concat(processedValues.filter(option => !option.isFixed));

  return { processedValues, longestOptionLength };
};
